import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Sparkles, ChevronRight } from 'lucide-react';
import { usePerfil } from '../../context/PerfilContext';
import { usePlus } from '../../context/PlusContext';
import { comprasDisponibles } from '../../utils/compras';

const fecha = (d: Date) => format(d, "d 'de' MMMM 'de' yyyy", { locale: es });

/** Tu plan, en Configuración → Perfil. Al tocarlo, la hoja de Plus. */
export const PlanPlus: React.FC = () => {
  const { estadoPlus } = usePerfil();
  const { ofrecerPlus } = usePlus();

  // Mientras no se pueda comprar y no haya límites, no hay nada que enseñar:
  // así una versión de la app sin Plus montado no anuncia algo «muy pronto».
  if (!comprasDisponibles && estadoPlus.motivo === 'sin-limites') return null;

  const texto = (() => {
    switch (estadoPlus.motivo) {
      case 'admin': return 'Administrador: todo sin límites';
      case 'vitalicio': return 'Plus de por vida';
      case 'regalado': return 'Plus regalado';
      case 'pagado': return `Plus hasta el ${fecha(estadoPlus.hasta!)}`;
      case 'regalo': return `Plus gratis hasta el ${fecha(estadoPlus.hasta!)}`;
      case 'sin-limites': return 'Todo gratis y sin límites, de momento';
      default: return 'Plan gratis';
    }
  })();

  return (
    <button type="button" onClick={() => ofrecerPlus()}
      className="w-full flex items-center gap-3 p-3 rounded-xl border border-amber-200 dark:border-amber-800
                 bg-amber-50 dark:bg-amber-900/20 text-left hover:border-amber-400 transition">
      <Sparkles className="w-5 h-5 shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="flex-1 min-w-0">
        <span className="block text-sm font-semibold text-gray-900 dark:text-white">myarinn Plus</span>
        <span className="block text-xs text-gray-600 dark:text-gray-400">{texto}</span>
      </span>
      <ChevronRight className="w-4 h-4 shrink-0 text-gray-400" />
    </button>
  );
};
